module.exports = __webpack_public_path__ + "static/media/symbols.757e3505.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/doctype-sprite/svg/symbols.svg
// module id = 454
// module chunks = 1